<template>
  <div
    :class="stats.canEdit ? 'justify-evenly' : 'justify-end mr-4'"
    class="flex flex-row items-center w-full space-x-2 md:space-x-4 lg:space-x-6"
  >
    <a
      v-if="stats.canEdit"
      href="#"
      @click.prevent="toggleQ"
      class="flex flex-row items-center justify-center space-x-3 pointer"
    >
      <svg class="flex-shrink-0 w-[30px] h-[30px]" viewBox="0 0 18 20">
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="0.205"
            y1="0.12"
            x2="0.904"
            y2="0.901"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stop-color="#ed1b24" />
            <stop offset="1" stop-color="#f97643" />
          </linearGradient>
        </defs>
        <g id="Document" transform="translate(0 0)">
          <path
            id="Document-2"
            data-name="Document"
            d="M13.191,20H4.81C1.753,20,0,18.236,0,15.16V4.83A4.91,4.91,0,0,1,1.265,1.271,4.863,4.863,0,0,1,4.81,0h8.382C16.247,0,18,1.761,18,4.83V15.16a4.891,4.891,0,0,1-1.246,3.583A4.819,4.819,0,0,1,13.191,20ZM5,13.736a.78.78,0,0,0-.668.374.786.786,0,0,0,.653,1.206.7.7,0,0,0,.1-.006H12.92a.79.79,0,0,0,0-1.57H5.08A.8.8,0,0,0,5,13.736ZM5.08,9.179a.78.78,0,0,0,0,1.561H12.92a.78.78,0,0,0,0-1.561Zm0-4.529v.01h0a.779.779,0,0,0,0,1.559h2.99a.785.785,0,0,0,0-1.57Z"
            fill="url(#linear-gradient)"
          />
        </g>
      </svg>
      <div class="flex flex-col">
        <p class="dark:text-white font-semibold text-[12px]">
          {{ t("footer.questions") }}
        </p>
        <p
          class="hidden md:block text-fire dark:text-gold font-semibold text-[12px]"
        >
          {{ stats.progress.percent }}% {{ t("footer.complete") }}
        </p>
      </div>
    </a>
    <a
      v-if="stats.canEdit"
      href="#"
      @click.prevent="toggleDoc"
      class="flex flex-row items-center justify-center space-x-3"
    >
      <svg class="flex-shrink-0 w-[37px] h-[37px]" viewBox="0 0 24 24">
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="0.263"
            y1="0.175"
            x2="0.846"
            y2="0.823"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stop-color="#ed1b24" />
            <stop offset="1" stop-color="#f97643" />
          </linearGradient>
        </defs>
        <g
          id="Paper_Download"
          data-name="Paper Download"
          transform="translate(3.5 2)"
        >
          <path
            id="Paper_Download-2"
            data-name="Paper Download"
            d="M4.674,20A4.7,4.7,0,0,1,0,15.29V4.51A4.493,4.493,0,0,1,4.465,0H9.752a.464.464,0,0,1,.455.46V3.68a3.341,3.341,0,0,0,3.308,3.34c.418,0,.79,0,1.119.006.256,0,.48,0,.673,0,.141,0,.323,0,.521,0,.229,0,.486-.005.716-.005A.448.448,0,0,1,17,7.47v8.04A4.478,4.478,0,0,1,12.544,20Zm.109-9.29a.755.755,0,0,0,0,1.06l2.831,2.87a.78.78,0,0,0,.238.159.7.7,0,0,0,.287.06.644.644,0,0,0,.277-.06.78.78,0,0,0,.238-.159l2.841-2.87a.747.747,0,0,0-.01-1.06.729.729,0,0,0-1.04,0l-1.574,1.6V7.49a.734.734,0,0,0-.733-.75.747.747,0,0,0-.743.75v4.82l-1.574-1.6a.729.729,0,0,0-1.04,0Zm8.86-5.151a2.017,2.017,0,0,1-2-2.017V.906a.472.472,0,0,1,.813-.334l3.987,4.187a.477.477,0,0,1-.34.807H15.46C14.819,5.568,14.156,5.565,13.642,5.559Z"
            fill="url(#linear-gradient)"
          />
        </g>
      </svg>
      <div class="flex flex-col">
        <p class="dark:text-white font-semibold text-[12px]">
          {{ t("footer.documents") }}
        </p>
        <p class="text-fire dark:text-gold font-semibold text-[12px]">
          {{ stats.files.current }} {{ t("dashboard.of") }}
          {{ stats.files.total }} {{ t("files") }}
        </p>
      </div>
    </a>
    <a
      v-if="stats.status !== 'withdrawn'"
      href="#"
      @click.prevent="toggleMsg"
      class="flex flex-row items-center justify-center space-x-3"
    >
      <div class="relative">
        <span
          v-show="stats.conversations"
          class="absolute right-0 rounded-full border-[#e2e2e2] dark:border-black border-[2px] bg-fire dark:bg-gold w-[14px] h-[14px]"
          >&nbsp;</span
        >
        <svg class="flex-shrink-0 w-[37px] h-[37px]" viewBox="0 0 24 24">
          <defs>
            <linearGradient
              id="linear-gradient"
              x1="0.368"
              y1="0.312"
              x2="0.692"
              y2="0.827"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#ed1b24" />
              <stop offset="1" stop-color="#f97643" />
            </linearGradient>
          </defs>
          <g id="Chat" transform="translate(2 2)">
            <path
              id="Chat-2"
              data-name="Chat"
              d="M10,20a9.955,9.955,0,0,1-4.92-1.3,2.2,2.2,0,0,0-1.107-.424,1.213,1.213,0,0,0-.383.063l-2.02.6a.754.754,0,0,1-.226.036.62.62,0,0,1-.5-.239.647.647,0,0,1-.094-.578l.67-2.244a1.046,1.046,0,0,0-.07-.9,10.566,10.566,0,0,1-1.35-5A10.158,10.158,0,0,1,2.831,3.032,9.89,9.89,0,0,1,10.02,0a9.865,9.865,0,0,1,7.12,2.994,10.058,10.058,0,0,1,2.1,3.182A9.89,9.89,0,0,1,20,9.985a10.138,10.138,0,0,1-.865,4.172,9.6,9.6,0,0,1-2.275,3.153A10.245,10.245,0,0,1,10,20ZM14.59,8.743a1.282,1.282,0,1,0,1.28,1.282A1.282,1.282,0,0,0,14.59,8.743Zm-4.629,0A1.268,1.268,0,0,0,8.7,10.015,1.28,1.28,0,1,0,9.98,8.743H9.961Zm-4.591,0a1.282,1.282,0,1,0,1.28,1.282A1.283,1.283,0,0,0,5.37,8.743Z"
              fill="url(#linear-gradient)"
            />
          </g>
        </svg>
      </div>
      <div class="flex flex-col">
        <p class="dark:text-white font-semibold text-[12px]">
          {{ t("footer.conversations") }}
        </p>
        <p
          class="hidden md:block text-fire dark:text-gold font-semibold text-[12px]"
        >
          {{ stats.conversations }} {{ t("footer.msg") }}
        </p>
      </div>
    </a>
    <div
      v-if="stats.canSubmit"
      class="flex flex-row items-center justify-center flex-shrink-0 mr-4"
    >
      <form method="POST" action="/applications">
        <input type="hidden" :value="csrf" name="_token" />
        <button
          type="submit"
          class="px-3 md:px-8 text-sm lg:text-base py-2 text-center bg-gold rounded-[8px]"
        >
          Send Application
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { computed, ref } from "vue";

export default {
  name: "FooterAction",
  props: {
    stats: {
      type: Object,
      default: {},
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();

    const csrf = computed(
      () => document.querySelector('meta[name="csrf-token"]').content
    );
    const totalFiles = computed(() => {
      const t = props.stats.files.total - props.stats.files.current;

      if (t < 0) return 0;

      return t;
    });
    const showAllQuestion = ref(false);
    const showAllDocuments = ref(false);
    const showAllMessages = ref(false);

    const toggleDoc = () => {
      showAllDocuments.value = !showAllDocuments.value;
      emit("toggle", "showAllDocuments", showAllDocuments.value);
    };

    const toggleQ = () => {
      showAllQuestion.value = !showAllQuestion.value;
      emit("toggle", "showAllQuestion", showAllQuestion.value);
    };

    const toggleMsg = () => {
      showAllMessages.value = !showAllMessages.value;
      emit("toggle", "showAllMessages", showAllMessages.value);
    };

    return {
      t,
      totalFiles,
      toggleQ,
      csrf,
      toggleDoc,
      toggleMsg,
    };
  },
};
</script>
